import Swiper from 'swiper/bundle';

(() => {
    const selector = ".swiper-events";
    let swiper = null;
    let container = document.querySelector(selector);

    run();

    function run() {

        if (container && !swiper) {
            swiper = initSwiper();
        }
    }

    function initSwiper() {
        return new Swiper(selector, {
            spaceBetween: 30,
            slidesPerView: 1.2,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                768: {
                  slidesPerView: 2.2,
                },
                1100: {
                    slidesPerView: 4.2,
                }
            }
        });
    }
})();
